import { is3pProduct } from '../client/common/selectors/3pProduct'

export const STORE_HOME_DELIVERY = 'SHD'
export const DROPSHIPMENT = 'DR'
export const CUSTOM_ORDER = 'CO'
export const PICKUP = 'CR'
export const DROPSHIPMENT_CUSTOM_ORDER = 'HC'
export const PICKUP_STOREHOME = 'DC'
export const PICKUP_CUSTOM_ORDER = 'ST'
export const PICKUP_DROPSHIPMENT = 'CD'
export const STOREHOME = 'EO'
export const MARKETPLACE = 'MP'

const STORE_HOME_DELIVERY_REGEXP = /^SHD/
const DROPSHIPMENT_REGEX = /^\d+(-[^-]+)?$/
const CUSTOM_ORDER_REGEXP = /^CUSTOMORDER/
const PICKUP_REGEXP = /^PICKUP$/

export const isStoreHomeDelivery = code => STORE_HOME_DELIVERY_REGEXP.test(code)
export const isDropshipment = code => DROPSHIPMENT_REGEX.test(code)
export const isCustomOrder = code => CUSTOM_ORDER_REGEXP.test(code)
export const isPickup = code => PICKUP_REGEXP.test(code)

const deliveryCodeMapping = [
  { fn: isStoreHomeDelivery, code: STORE_HOME_DELIVERY },
  { fn: isDropshipment, code: DROPSHIPMENT },
  { fn: isCustomOrder, code: CUSTOM_ORDER },
  { fn: isPickup, code: PICKUP }
]

export const getGroupNameByDeliveryModes = productDetails => {
  const { deliveryModes } = productDetails

  if (deliveryModes?.every(mode => isStoreHomeDelivery(mode.code))) {
    return STOREHOME
  }
  if (deliveryModes?.every(mode => isDropshipment(mode.code))) {
    return DROPSHIPMENT
  }
  if (deliveryModes?.every(mode => isPickup(mode.code))) {
    return PICKUP
  }
  if (deliveryModes?.every(mode => isCustomOrder(mode.code))) {
    return CUSTOM_ORDER
  }
  if (deliveryModes?.every(mode => isDropshipment(mode.code) || isCustomOrder(mode.code))) {
    return DROPSHIPMENT_CUSTOM_ORDER
  }
  if (deliveryModes?.every(mode => isPickup(mode.code) || isStoreHomeDelivery(mode.code))) {
    return PICKUP_STOREHOME
  }
  if (deliveryModes?.every(mode => isPickup(mode.code) || isCustomOrder(mode.code))) {
    return PICKUP_CUSTOM_ORDER
  }
  if (deliveryModes?.every(mode => isPickup(mode.code) || isDropshipment(mode.code))) {
    return PICKUP_DROPSHIPMENT
  }
  if (is3pProduct(productDetails)) {
    return MARKETPLACE
  }
}

export const unifyCode = code => {
  return deliveryCodeMapping.find(it => it.fn(code))?.code || null
}

const ONLINE_ONLY_CODES = [DROPSHIPMENT, STORE_HOME_DELIVERY]
export function isOnlineOnly(deliveryModes, useMaxedaOfferAsWinner, offers) {
  const uniqueDeliveryCodes = [...new Set(deliveryModes?.map(mode => unifyCode(mode.code)))]
  const showLabel = uniqueDeliveryCodes.length === 1 && ONLINE_ONLY_CODES.includes(uniqueDeliveryCodes[0])
  return showLabel || (useMaxedaOfferAsWinner !== true && offers?.length > 0)
}
